module.exports = __webpack_public_path__ + "img/tool-icon.a2036b1c.svg";